import { IonIcon } from "@ionic/react";
import {
  alertCircleSharp,
  checkmarkCircleSharp,
  informationCircleSharp,
} from "ionicons/icons";
import styled, { keyframes } from "styled-components";
import { devices } from "../../Devices";
import { useEffect } from "react";

const slideInLeft = keyframes`
  from {
    transform: translateX(120%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const Container = styled.div`
  color: #ffffff;
  position: fixed;
  top: 5rem;
  right: 2rem;
  font-size: 1.4rem;
  font-weight: bold;
  text-transform: uppercase;
  width: 30rem;
  height: auto;
  padding: 2rem;
  gap: 1.2rem;
  animation: ${slideInLeft} 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  z-index: 20;
  ${({ type }) =>
    type === "error"
      ? `
      background-color: #ff3333;
  `
      : type === "info"
      ? `
      background-color: #d97706;
  `
      : `
      background-color: #00D100;
  `}
  .icon {
    color: #ffffff;
    font-size: 1.6rem;
  }

  @media (${devices.mobileL}) {
    font-size: 1.2rem;
    width: 30rem;
    .icon {
      font-size: 1.4rem;
    }
  }
`;

export default function Notification({
  message,
  type,
  autoHide = false,
  duration = 3000,
  onClose,
}) {
  useEffect(() => {
    if (autoHide && onClose) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [autoHide, duration, onClose]);

  return (
    <Container type={type} className={`flex align`}>
      <IonIcon
        className="icon"
        icon={
          type === "error"
            ? alertCircleSharp
            : type === "success"
            ? checkmarkCircleSharp
            : informationCircleSharp
        }
      />{" "}
      {message}
    </Container>
  );
}
